<div class="loading-indicator" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
</div>
<div class="d-flex">
  <div class="col-2"></div>
  <div class="col-8">
    <div fxLayoutAlign="center" style="margin-top: 20px;">
      <h1>{{data?.exemptionRequestType?.description}}</h1>
    </div>
    <div class="row">
      <div>
        <mat-tab-group [selectedIndex]="selectedIndex" #tabs (selectedTabChange)="tabChanged($event)">
          <mat-tab  *ngIf="isCorrection" label="Verification">
            <app-external-verification-tab [QualificationTab]="VerificationTab"
              [QualificationTypes]="qualificationTypes" [IsVerificationCorrection]="IsVerificationCorrection" [verificationError]="verificationError" >
            </app-external-verification-tab>
          </mat-tab>
          <mat-tab *ngIf="isCorrectQualification" label="Qualification">
            <app-qualificationtab (ecnTabOut)="onEcnFocusOutEvent($event)" (feinTabOut)="onFeinFocusOutEvent($event)" [IsExternal]="true" [QualificationTab]="QualificationTab" [QualificationTypes]="qualificationTypes">
            </app-qualificationtab>
          </mat-tab>
          <mat-tab label="Physical Address">
            <app-addresstabs [AddressTab]="PhysicalAddressTab" [CountryTypes]="countryTypes" [StateTypes]="stateTypes">
            </app-addresstabs>
          </mat-tab>
          <mat-tab label="Mailing Address">
            <app-addresstabs [IsMailingAddressTab]="true" [AddressTab]="MailingAddressTab" [CountryTypes]="countryTypes"
              [StateTypes]="stateTypes"></app-addresstabs>
          </mat-tab>
          <mat-tab label="License">
            <app-licensetab [CountyTypes]="countyTypes" [CityTypes]="cityTypes" [LicenseTab]="LicenseTab">
            </app-licensetab>
          </mat-tab>
          <mat-tab label="Confirmation">
            <app-confirmationtab [IsExternal]="true" [CsPLicense]="data?.cspLicense"  [FillingType]="data?.exemptionRequestType?.code"
              [QualificationTypes]="qualificationTypes" [CountyTypes]="countyTypes" [CityTypes]="cityTypes"
              [StateTypes]="stateTypes" [ParentForm]="form" [ConfirmationTab]="ConfirmationTab"></app-confirmationtab>
          </mat-tab>
          <mat-tab label="Upload">
            <app-upload-tab [SavedUploadMode]="data?.paymentAndUploadMode" (onPaymentUploadTypeChange)="paymentAndUploadModeSelected($event)"></app-upload-tab>
          </mat-tab>
          <mat-tab label="Signature">
            <app-signaturetab [SignatureTab]="SignatureTab"></app-signaturetab>
          </mat-tab>
          <mat-tab label="Payment">
            <ng-template matTabContent>
              <app-exernal-payment-tab [isCorrectQualification]="isCorrectQualification" [PaymentUploadMode]="paymentAndUploadMode" [ParentForm]="form">
              </app-exernal-payment-tab>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div  class="row" style="margin-top: 20px;margin-bottom: 130px;">
      <div class="col-4">
        <button *ngIf="selectedIndex > 0" mat-raised-button
          style="margin-left: '30px'; border-radius: 5px; background-color: '#e7e3e3'; color: 'black';"
          [disabled]="isLoading" (click)="previousStep()">Back</button>
      </div>
      <div *ngIf="selectedTabHeader != 'Payment'" class="col-4">
        <div><button [disabled]="isLoading" mat-raised-button color="primary" (click)="saveAndContinue()">Save & Continue</button></div>
      </div>
      <div *ngIf="selectedTabHeader != 'Payment'" class="col-4" fxFlex fxLayoutAlign="end start">
        <button mat-raised-button
          style="border-radius: 5px; background-color: '#e7e3e3'; color: 'black'; margin-right: 100px;"
          (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </div>
  <div fxLayoutAlign="start"class="col-2">
    <div *ngIf="selectedTabHeader == 'Upload'" style="margin-top: 150px; ">
      <dl>
        <dt style="text-decoration: underline">Required Documents:</dt>
        <dd *ngIf="data?.exemptionRequestType?.code == 'INITIAL' || data?.exemptionRequestType?.code == 'SUBSEQUENT'">IRS 147 (C) FEIN Confirmation Letter</dd>
        <dd *ngIf="(data?.exemptionRequestType?.code == 'INITIAL' || data?.exemptionRequestType?.code == 'SUBSEQUENT') 
        && ( data?.qualificationType?.code == 'RELSECTBUSINESSENT' || data?.qualificationType?.code == 'RELSECTSOLEPROP' )">Religious Conscientious Objection Affidavit</dd>
        <dd *ngIf="(data?.exemptionRequestType?.code == 'INITIAL' || data?.exemptionRequestType?.code == 'SUBSEQUENT') 
        && ( data?.qualificationType?.code == 'RELSECTBUSINESSENT' || data?.qualificationType?.code == 'RELSECTSOLEPROP' )">4029 Application for Exemption From Social Security and Medicare Taxes and Waiver of Benefits</dd>

        <dd *ngIf="(data?.exemptionRequestType?.code == 'RENEWAL' || data?.exemptionRequestType?.code == 'SUBRENEWAL'
                    || data?.exemptionRequestType?.code == 'REINSTATE'|| data?.exemptionRequestType?.code == 'SUBREINSTATE'
                    || data?.exemptionRequestType?.code == 'CORRECTION') 
        && ( data?.qualificationType?.code == 'RELSECTBUSINESSENT' || data?.qualificationType?.code == 'RELSECTSOLEPROP' )">Religious Conscientious Objection Affidavit</dd>
        <dd *ngIf="data?.exemptionRequestType?.code == 'CORRECTION' && isCorrectQualification">IRS 147 (C) FEIN Confirmation Letter</dd>

        <dd *ngIf="(data?.exemptionRequestType?.code == 'INITIAL' || data?.exemptionRequestType?.code == 'CORRECTION') && standingStatus == 0">Tax Clearance Letter is Required</dd>

        <dd *ngIf="(data?.exemptionRequestType?.code == 'CORRECTION') && isCorrectQualification
        && ( data?.qualificationType?.code == 'RELSECTBUSINESSENT' || data?.qualificationType?.code == 'RELSECTSOLEPROP' )">4029 Application for Exemption From Social Security and Medicare Taxes and Waiver of Benefits</dd>
      </dl>
    </div>
  </div>
</div>
